import { render, staticRenderFns } from "./tournamentWinners.vue?vue&type=template&id=3831b294&scoped=true&"
import script from "./tournamentWinners.vue?vue&type=script&lang=js&"
export * from "./tournamentWinners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831b294",
  null
  
)

export default component.exports